import { reduce, map } from 'lodash';

type BuildQueryString = (obj?: { [key: string]: any }) => string;

export const buildQueryString: BuildQueryString = obj => {
  if (obj) {
    const filteredObj = reduce(
      obj,
      (filteredObj, value, key) => {
        if (value) {
          return {
            ...filteredObj,
            [key]: value,
          };
        }

        return filteredObj;
      },
      {},
    );

    const queryParams = map(filteredObj, (value, key) => [key, value])
      .map(pair => pair.map(encodeURIComponent).join('='))
      .join('&');

    return `?${queryParams}`;
  }

  return '';
};
